module.exports = __webpack_public_path__ + "docs/img/android-chrome-192x192.c1c02846.png";